module.exports = __webpack_public_path__ + "img/sdg9_id.68770acc.svg";